import api from '../lib/api';

export const FETCH_ALL_VEHICLES = 'FETCH_ALL_VEHICLES';
export const FETCH_MARKET_VEHICLES = 'FETCH_MARKET_VEHICLES';
export const FETCH_VEHICLE_TRIPS_BY_ID = 'FETCH_VEHICLE_TRIPS_BY_ID';
export const VEHICLES_LOADING = 'VEHICLES_LOADING';
export const ONE_VEHICLE_LOADING = 'ONE_VEHICLE_LOADING';
export const VEHICLES_LOST_LOADING = 'VEHICLES_LOADING';
export const CLEAR_MARKET_VEHICLES = 'CLEAR_MARKET_VEHICLES';
export const FETCH_MARKET_LOST_DECOMMISSIONED_VEHICLES = 'FETCH_MARKET_LOST_DECOMMISSIONED_VEHICLES';
export const FETCH_VEHICLE_ACTIVITIES = 'FETCH_VEHICLE_ACTIVITIES';
export const FETCH_VEHICLE_HISTORY = 'FETCH_VEHICLE_HISTORY';

function fetchVehicleHistory(vehicleId) {
  return (dispatch) => api.getVehicleHistory(vehicleId).then((response) => {
    dispatch({ type: FETCH_VEHICLE_HISTORY, payload: response.data });
    return response;
  });
}

export default {
  fetchVehicleHistory,
  fetchVehicles(query) {
    return (dispatch) => {
      dispatch({ type: VEHICLES_LOADING, payload: true });

      return api
        .getVehicles(query)
        .then((data) => {
          if (query) {
            dispatch({ type: FETCH_MARKET_VEHICLES, payload: data });
          } else {
            dispatch({ type: FETCH_ALL_VEHICLES, payload: data });
          }
          return data;
        })
        .then((data) => {
          dispatch({ type: VEHICLES_LOADING, payload: false });
          return data;
        })
        .catch((data) => {
          dispatch({ type: VEHICLES_LOADING, payload: false });
          return data;
        });
    };
  },
  fetchLostDeletedVehicles(query) {
    return (dispatch) => {
      dispatch({ type: VEHICLES_LOST_LOADING, payload: true });

      return api
        .getVehicles(query)
        .then((data) => {
          dispatch({ type: FETCH_MARKET_LOST_DECOMMISSIONED_VEHICLES, payload: data });
          dispatch({ type: VEHICLES_LOST_LOADING, payload: false });
          return data;
        })
        .catch((data) => {
          dispatch({ type: VEHICLES_LOST_LOADING, payload: false });
          return data;
        });
    };
  },
  fetchVehicleActivities(marketId) {
    const query = { market_id: marketId };
    return (dispatch) => {
      dispatch({ type: VEHICLES_LOADING, payload: true });

      return api
        .getVehicleActivityDates(query)
        .then((data) => {
          dispatch({
            type: FETCH_VEHICLE_ACTIVITIES, payload: { vehicles: data, marketId },
          });
        })
        .then(() => {
          dispatch({ type: VEHICLES_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: VEHICLES_LOADING, payload: false });
        });
    };
  },
  clearMarketVehicles() {
    return (dispatch) => {
      dispatch({ type: CLEAR_MARKET_VEHICLES, payload: [] });
    };
  },
  fetchVehicleTripsById(vehicleId) {
    return async (dispatch) => {
      dispatch({ type: VEHICLES_LOADING, payload: true });

      const data = await api.getVehicleTripsById(vehicleId);
      dispatch({ type: FETCH_VEHICLE_TRIPS_BY_ID, payload: data });
      dispatch({ type: VEHICLES_LOADING, payload: false });
    };
  },
  updateVehicle(vehicle, vehicleId) {
    return () => api.updateVehicle(vehicle, vehicleId);
  },
  unlockVehicle(vehicleId) {
    return () => api.unlockVehicle(vehicleId);
  },
  lockVehicle(vehicleId) {
    return () => api.lockVehicle(vehicleId);
  },
  ringVehicle(vehicleId) {
    return () => api.ringVehicle(vehicleId);
  },
  startRingingVehicle(vehicleId) {
    return () => api.startRingingVehicle(vehicleId);
  },
  stopRingingVehicle(vehicleId) {
    return () => api.stopRingingVehicle(vehicleId);
  },
  bulkUpdateStatus(arrayOfVehicleExtIds, deploymentStatus, possessionStatus) {
    return () => api.bulkUpdateVehicleStatus(
      arrayOfVehicleExtIds,
      deploymentStatus,
      possessionStatus,
    );
  },
};
